import { Stack, Typography, styled } from '@mui/material';

interface IStackStyledProps {
  attrs: {
    selected?: boolean;
  };
}

export const StackStyled = styled(Stack)<IStackStyledProps>(
  ({ theme, attrs: { selected } }) => ({
    backgroundColor: theme.palette.white.main,
    minWidth: '180px',
    borderRadius: theme.spacing(2),
    cursor: 'pointer',
    padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
    ...(selected && {
      border: `1px solid ${theme.palette.primary.main}`,
    }),
  }),
);
export const TypographyStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.dark.dark_4,
}));
